import React,{Suspense} from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import { routers } from './consts/routers';
import Loading from './utilits/Loading/Loading';

function App() {
  return (
    <div className="app">
      <Navbar />
      <div className="mainBlock">
        <Switch>
          <Suspense fallback={<Loading/>}>
            {
              routers.map(({ path, Component }) => (
                <Route key={path} path={path} component={Component} exact />
              ))
            }
          </Suspense>
          <Redirect to="/" />
        </Switch>
      </div>
      <Footer />
    </div>
  );
}

export default App;
